export default function isLoggin() {
    if(localStorage.getItem('user') != null)
    {  
      return true
    }

    return false;
  }
  